/** Meta Pixel ID — must stay in sync with the guard in public/index.html. */
export const META_PIXEL_ID =
  process.env.REACT_APP_FACEBOOK_PIXEL_ID || '1391058338596597';

/** Known stray pixels to block (e.g. old agency / duplicate install). */
export const BLOCKED_META_PIXEL_IDS = ['1072526954699493'];

const META_PIXEL_ALLOWED_HOSTS = ['daivbharathi.com', 'www.daivbharathi.com'];

export function isMetaPixelAllowedHost(hostname) {
  const host = String(hostname || '').toLowerCase().replace(/^www\./, 'www.');
  return META_PIXEL_ALLOWED_HOSTS.includes(host);
}

export function isMetaPixelAllowedOnCurrentHost() {
  if (typeof window === 'undefined') return false;
  return isMetaPixelAllowedHost(window.location.hostname);
}

export function isBlockedMetaPixelId(pixelId) {
  const id = String(pixelId || '');
  if (!id) return false;
  if (id === META_PIXEL_ID) return false;
  return true;
}
